import { render, staticRenderFns } from "./Flask.vue?vue&type=template&id=5b38ee20&scoped=true&"
import script from "./Flask.vue?vue&type=script&lang=js&"
export * from "./Flask.vue?vue&type=script&lang=js&"
import style0 from "./Flask.vue?vue&type=style&index=0&id=5b38ee20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b38ee20",
  null
  
)

export default component.exports